import { NextRouter, useRouter } from 'next/router';

export const getRouteMatch = (
  href: string | string[] | null,
  router: NextRouter,
  options?: { isExact?: boolean }
): boolean => {
  if (href === null) {
    return false;
  }

  if (Array.isArray(href)) {
    return href.some((singleHref) =>
      getRouteMatch(singleHref, router, options),
    );
  }

  const path = router.asPath.split('?')[0];

  return options?.isExact
    ? path === href
    : path === href || path.startsWith(`${href}/`);
};

export const useRouteMatch = (
  href: string | string[] | null,
  options?: { isExact?: boolean }
): boolean => {
  const router = useRouter();

  return getRouteMatch(href, router, options);
};
